import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import MaterialTable from 'material-table';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

import { PaginatedResponse } from '../../../shared/models';
import { Typography, Link, Select, MenuItem } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import EditIcon from '@material-ui/icons/Edit';
import { API_URLS, getCCRSReportHeaders } from '../../api';
import composeRequest from '../../../shared/api/core';
import { checkStatus, parseJSON, handleError } from '../../../shared/api/core/common';
import { SVG_ICONS } from '../../../shared/icons/SvgIcons';
import { BusinessRouterPaths, MasterDataRouterPaths } from '../../../page/Routes/RouterPaths';
import { ErrorStatusBar, CustomTableTitle, ExportMenu, ExportStatusBar, } from '../../../shared/components';
import { EMPTY_ROW_MSG, ERROR_500, ERROR_MSG } from '../../../shared/lib/Localization';
import { initQueryParams, replaceHistory, tableOptions, useQuery } from '../../../shared/lib/TableQueryParams';
import download from 'downloadjs';
import { getCCRSReportDetailList, saveFileContentDetailErrorMsgs } from '../../api';
import { Toast, enqueueSnackbar, ToastSuccess, ToastError, ToastWarning } from '../../../shared/components/Notifier';
import GlobalStyles from '../../../../styles/GlobalStyles.web';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
// import cloneDeep from 'lodash/cloneDeep';
import sortBy from 'lodash/sortBy';



const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    formControl: {
      // margin: theme.spacing(1),
      minWidth: 120,
      width: '100%',
      maxWidth: '16rem'
    },
    progress: {
      margin: theme.spacing(2),
    },
    statusText: {
      fontSize: 16,
      textAlign: 'left',
      marginLeft: 58,
      padding: "6px 0",
      display: 'flex',
      alignItems: 'center'
    },
    panelRowText: {
      fontSize: '0.9375rem',
      alignSelf: 'center',
      // padding: '0 8px'
    },
    dialogContent: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',

    }
  }),
);


const CCRSReportDetailListScreen = (props: any) => {
  const classes = useStyles({});
  const tableRef = useRef<{ onQueryChange: any; }>();
  const [emptyDataSourceMessage, setEmptyDataSourceMessage] = useState(EMPTY_ROW_MSG);
  const [isErrorStatusVisible, setErrorStatusVisible] = useState(false);
  let locationQuery = useQuery(useLocation);
  const [tableQuery, setTableQuery] = useState(initQueryParams(locationQuery));
  const [isLoading, setLoading] = useState(false);
  const [isExporting, setExporting] = useState(false);
  const [exportBtnAnchorEl, setExportBtnAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedFileDetailContent, setSelectedFileDetailContent] = useState([]);
  const [isModalLoading, setModalLoading] = useState(false)
  const [updatedRows, setUpdatedRows]= useState(null as any);
  const [fullData, setFullData] = useState(null);
  const [responseData, setReponseData] = useState(null);
  const [headersData, setHeadersData] = useState([]);
  const [columnsData, setColumnsData] = useState([]);
  const [ccrsUploadErrorData, setCcrsUploadErrorData] = useState({});
  
  const [dialogBoxOpen, setDialogBoxOpen] = useState(false);
  const [currentRowData, setCurrentRowData] = useState<any>(null);
  const [editRowData, setEditRowData] = useState<any>(null);


  // useEffect(()=>{
  //   console.log("updatedRows", updatedRows)
  // },[updatedRows]);

  
  useEffect(() => {
    if (!isLoading) {
      tableRef.current && tableRef.current.onQueryChange();
      setFullData(null);
      setReponseData(null);
      const sb = props.userData.selectedBusiness;
      getCCRSReportHeaders(props.match.params.id, sb.business_id)
          .catch(handleError) // handle network issues
          .then(checkStatus)
          .then((res) => res.json())
          .then((res) => {
            setHeadersData(res)
            const headers = getTableColumns(res);
            setColumnsData(headers);
          });
    }
  }, [props.userData.selectedBusiness]);

  const handleRefresh =()=>{
    tableRef.current && tableRef.current.onQueryChange();
    setFullData(null)
    setReponseData(null)
  }

  // useEffect(() => {
    
  // }, [headersData])





  const exportCSV = (rowData?: any) => {
    if (props.userData && props.userData.selectedBusiness) {
      setExporting(true);
      const sb = props.userData.selectedBusiness;
      const shouldExport = true;
      getCCRSReportDetailList(
        props.match.params.id,
        sb.business_id,
        null,
        null,
        tableQuery.search,
        sb.orderBy,
        shouldExport,
        rowData ? rowData.file_name : null
      )
        .catch(handleError) // handle network issues
        .then(checkStatus)
        .then((res) => res.blob())
        .then((data) => {
          download(data, `${rowData.file_name}`);
          setExporting(false);
        })
        .catch((error: any) => {
          setExporting(false);
          if (error) {
            let errorMsg = 'Failed to Download'
            if (error.status && error.status === 500) {
              errorMsg = ERROR_MSG
              setEmptyDataSourceMessage(ERROR_MSG);
              setErrorStatusVisible(false);
            } else if (error.status === 403 || error.status === 401) {
              setEmptyDataSourceMessage(ERROR_MSG);
              setErrorStatusVisible(true);
            } else {
              setEmptyDataSourceMessage(ERROR_MSG);
              setErrorStatusVisible(false);
            }
            props.showToast({
              message: `${errorMsg}`,
              options: ToastError
            });
          }
        });
    }
  };

  const handleExportClick = (event: React.MouseEvent<HTMLButtonElement>, rowData: any) => {
    console.log("rowData", rowData)
    // let dlLink = rowData.ftp_core && rowData.ftp_core.source
    // download(dlLink)
    // window.open(dlLink)
    exportCSV(rowData)
  };

  const handleExportMenuClose = (shouldExport: boolean) => {
    if (shouldExport) {
      exportCSV();
    }
    setExportBtnAnchorEl(null);
  };



  const handleSave = () => {
    if (selectedFileDetailContent && selectedFileDetailContent.length > 0) {
      let selectedData = fullData.filter(o1 => selectedFileDetailContent.some(o2 => o1.id === o2.id));
      console.log("SelectedData", selectedData)

      const sb = props.userData.selectedBusiness
      let payload = {
        business_id: sb.business_id,
        file_contents: selectedData
      }

      saveFileContentDetailErrorMsgs(payload)
        .catch(handleError) // handle network issues
        .then(checkStatus)
        .then(parseJSON)
        .then((data) => {
          handleRefresh()
          setLoading(false)
        })
        .catch((err: any) => {
          setLoading(false)
        });

    }
  }


  const handleChangeErrorDetail = (e: any) => {
    console.log("CCRSError value - ", e.target.value);
    let currentValues = {}
    if (editRowData) {
      currentValues = {...editRowData}
    }
    currentValues['CCRSError'] = e.target.value;
    setEditRowData(currentValues);
  }
  const handleChangeCommentsDetail = (e:any) => {
    console.log("Comments value - ", e.target.value);
    let currentValues = {}
    if (editRowData) {
      currentValues = {...editRowData}
    }
    currentValues['Comments'] = e.target.value;
    setEditRowData(currentValues);
  }


  // const getErrorMsg =(rowData) =>{
  //   let data = cloneDeep(fullData)
  //   let rowIndex = data.findIndex((row: any) => row.id === rowData.id)
  //   // console.log("getErrorMsg", data)
  //   return data[rowIndex]['error_details']

  // }

  const getTableColumns = (hData?: any) => {
    const remoteHeaders = hData ? hData : (headersData ? headersData : []); 
    const constantHeaders = [
      // {

      //   title: 'Edit',
      //   field: 'Edit',
      //   editable: 'never',
      //   render: rowData => {
      //     return <IconButton onClick={() => handleShowEditRecord(rowData)} color="primary" autoFocus><EditIcon /></IconButton>;
      //   }
      // },
      {

        title: 'External Identifier',
        field: 'ExternalIdentifier',
        editable: 'never',
        render: rowData => {
          if (rowData.ExternalIdentifier) {
            return <Typography variant="subtitle2">{rowData.ExternalIdentifier}</Typography>;
          }
          return <Typography variant="subtitle2" ></Typography>;
        }
      },
      {
        title: 'Status',
        field: 'UploadStatus',
        editable: 'never',
        render: rowData => {
          if (rowData.UploadStatus) {
            return <Typography variant="subtitle2">{rowData.UploadStatus}</Typography>;
          }
          return <Typography variant="subtitle2" ></Typography>;
        }
      },
    ];
    const orderedHeaders = remoteHeaders.filter(h => h.indexOf("ExternalIdentifier", "UploadStatus") < 0)
                                      .map(h => {
                                        return {

                                          title: h,
                                          field: h,
                                          editable: 'never',
                                          render: rowData => {
                                            if (rowData.hasOwnProperty(h)) {
                                              return <Typography variant="subtitle2" style={{ minWidth: rowData[h] != null ? "250px" : null, paddingRight: 10, }}>{rowData[h]}</Typography>;
                                            }
                                            return <Typography variant="subtitle2" ></Typography>;
                                          }
                                        }
                                      });
    const headers = [...constantHeaders, ...orderedHeaders]
    return headers;
  }

  const handleStatusChange = (e: any) => {
    console.log("status value - ", e.target.value);
    let currentValues = {}
    if (editRowData) {
      currentValues = {...editRowData}
    }
    currentValues['UploadStatus'] = e.target.value;
    setEditRowData(currentValues);
  }
  
  const renderStatusOptions = () => {
    const options = [
      {"id": "GENERATED", "label": 'Generated'},
      {"id": "UPLOADED", "label": 'Uploaded'},
      {"id": "CCRS_ERRORED", "label": 'CCRS Errored'},
      {"id": "TO_RESUBMIT", "label": 'To Resubmit'},
      {"id": "SUCCESSFUL", "label": 'Successful'}
    ]
    return options.map((o, i) => {
      return (
        <MenuItem key={`opt-${i}`} value={o.id}>
          {o.label}
        </MenuItem>
      );
    });
  };

  const handleDialogBoxCancel = () => {
    setDialogBoxOpen(false);
  }
  const handleShowEditRecord = (rowData: any) => {
    setCurrentRowData(rowData);
    setDialogBoxOpen(true);
  }

  const renderEditRecordDialogBox = () => {
    return (
      <div>
        {
          <Dialog
            open={dialogBoxOpen}
            onClose={handleDialogBoxCancel}
            fullWidth={true}
            maxWidth="xs"
          >
            <DialogTitle style={{ color: GlobalStyles.primaryColor }}>Edit CCRS Record</DialogTitle>
            <DialogContent style={{ padding: "10px", }}>
              {/* {
                currentRowData && <div className={classes.dialogContent} >
                <div><h3>{currentRowData.ExternalIdentifier}</h3></div>
                  <FormControl fullWidth variant="outlined" className={classes.formControl} style={{width: '100%'}}>
                    <InputLabel id="demo-simple-select-outlined-label">Upload Status</InputLabel>
                    <Select
                      // label="Template"
                      labelId="demo-simple-select-outlined-label"
                      id={`listing-templates`}
                      // value={getStatusValueForRow(rowData)}
                      value={editRowData ? editRowData.UploadStatus : ""}
                      onChange={(e) => handleStatusChange(e)}
                      // variant="outlined"
                      style={{ width: '12rem' }}
                      label={`Status`}
                      fullWidth={true}
                      margin="dense"
                    >
                      {renderStatusOptions()}
                    </Select>
                  </FormControl>
                  <TextField
                    id={String(currentRowData.id)}
                    autoFocus
                    margin="dense"
                    size="medium"
                    multiline
                    // value={getErrorMsgValueForRow(rowData)}
                    value={editRowData ? editRowData.CCRSError : ""}
                    onChange={(e)=>handleChangeErrorDetail(e)}
                    label="Enter the Error Msg"
                    type="text"
                    // style={{ width: '12rem' }}
                  />
                  <TextField
                    id={String(currentRowData.id)}
                    autoFocus
                    margin="dense"
                    size="medium"
                    multiline
                    // value={getCommentsValueForRow(rowData)}
                    value={editRowData ? editRowData.Comments : ""}
                    onChange={(e)=>handleChangeCommentsDetail(e)}
                    label="Enter Comments"
                    type="text"
                    // style={{ width: '12rem' }}
                  />
                
                </div>
              } */}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDialogBoxCancel} color="primary" autoFocus>
                Cancel
              </Button>
              <Button onClick={() => handleSave()} style={{ color: "#ff1744" }} disabled={false} >
                OK
              </Button>
            </DialogActions>
          </Dialog>
        }
      </div>
    )
  }


  return (
    <div>
      <ErrorStatusBar isVisible={isErrorStatusVisible} />
      <ExportStatusBar isVisible={isExporting} />

      <div style={{ maxWidth: '100%' }}>
        <div className="table-wrapper">
          {columnsData && <MaterialTable
            options={{
              ...tableOptions(tableQuery),
              thirdSortClick: false,
              draggable: false,
              sorting: false,
              selection: false,
              selectionProps: rowData => ({
                color: 'secondary',
                // disabled: rowData.retl_item_code.includes('z') ? true : rowData.retl_item_code.includes('Z') ? true : false
              }),
              showTextRowsSelected: false,
            }}
            tableRef={tableRef}
            localization={{
              body: {
                emptyDataSourceMessage: emptyDataSourceMessage
              }
            }}
            // initialState={{ columnVisibility: { address: false } }}
            columns={columnsData}
            // columns = {[
            //   {
        
            //     title: 'External Identifier',
            //     field: 'ExternalIdentifier',
            //     editable: 'never',
            //     render: rowData => {
            //       if (rowData.ExternalIdentifier) {
            //         return <Typography variant="subtitle2">{rowData.ExternalIdentifier}</Typography>;
            //       }
            //       return <Typography variant="subtitle2" ></Typography>;
            //     }
            //   },
            //   {
            //     title: 'Status',
            //     field: 'UploadStatus',
            //     editable: 'never',
            //     render: rowData => {
            //       if (rowData.UploadStatus) {
            //         return <Typography variant="subtitle2">{rowData.UploadStatus}</Typography>;
            //       }
            //       return <Typography variant="subtitle2" ></Typography>;
            //     }
            //   },
            // ]}
            onSelectionChange={(data: any) => {
              setSelectedFileDetailContent(data)
            }
            }
            data={query =>
              new Promise((resolve, reject) => {
                if (!isLoading) {
                  // console.log('query', query);
                  let file_id = props.match.params.id
                  const sb = props.userData.selectedBusiness;
                  if (sb && sb.business_id) {
                    replaceHistory(query, props.history);
                    let pageData = {
                      data: [] as any[],
                      totalCount: 0,
                      page: query.page
                    };
                    let orderBy = '';
                    if (query.orderBy) {
                      orderBy = query.orderBy.field as string;
                      orderBy = `${query.orderDirection && query.orderDirection === 'desc' ? '-' : ''}${orderBy}`;
                    }
                    setLoading(true);

                    
                    
                    getCCRSReportDetailList(
                      file_id,
                      sb.business_id,
                      query.page + 1,
                      query.pageSize,
                      query.search,
                      orderBy,
                      false
                    )
                      .catch(handleError) // handle network issues
                      .then(checkStatus)
                      .then(parseJSON)
                      .then((data: any) => {
                        setErrorStatusVisible(false);
                        setEmptyDataSourceMessage(EMPTY_ROW_MSG);
                          // setFullData(data.results);
                        pageData = {
                          data: data.results,
                          totalCount: data.count,
                          page: query.page
                        };
                        setTableQuery({
                          ...tableQuery,
                          orderBy,
                          totalCount: data.count,
                          page: query.page,
                          pageSize: query.pageSize
                        });
                        resolve(pageData);
                        setLoading(false);
                      })
                      .catch((error: any) => {
                        if (error) {
                          if (error.status && error.status === 500) {
                            setEmptyDataSourceMessage(ERROR_500);
                            setErrorStatusVisible(false);
                          } else if ((error.status === 403 || error.status === 401)
                          ) {
                            setEmptyDataSourceMessage(ERROR_MSG);
                            setErrorStatusVisible(true);
                          } else {
                            setEmptyDataSourceMessage(ERROR_MSG);
                            setErrorStatusVisible(false);
                          }
                        }
                        setTableQuery({
                          ...tableQuery,
                          totalCount: 0,
                          page: query.page,
                          pageSize: query.pageSize
                        });
                        resolve(pageData);
                      });

                    }
                  // }

                }
              })
            }
            title={
              <CustomTableTitle
                history={props.history}
                title={'Report Detail'}
                icon={SVG_ICONS.reports} />
            }
            actions={[

              {
                icon: 'refresh',
                tooltip: 'Refresh Data',
                isFreeAction: true,
                onClick: () =>handleRefresh(),
              },
              // {
              //   icon: 'save',
              //   tooltip: 'Save',
              //   position: "toolbarOnSelect",
              //   onClick: () => handleSave(),
              // },
            ]}
            // onRowClick={(event, rowData, togglePanel) => togglePanel()}
            detailPanel={rowData => {
              // console.log("RowData", rowData)
              return (
                <div id={String(rowData.id)} style={{ marginLeft: 15 }} >
                  <Button onClick={() => handleShowEditRecord(rowData)} color="primary" autoFocus>
                    Edit CCRS Record
                  </Button>
                </div>

              )

            }
            }

          />}
        </div>
      </div>
      {/* <ExportMenu anchorEl={exportBtnAnchorEl} handleClose={handleExportMenuClose} /> */}
      {renderEditRecordDialogBox()}

    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userData: state.userLocalData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    showToast: (toast: Toast) => dispatch(enqueueSnackbar(toast))
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(CCRSReportDetailListScreen);
